// ─────────────────────────────────────────────────────────────────────────────
// SessionsTab.js — ACTIVE SESSIONS cards (region + live badge, IP + duration).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../UserDetailModal.module.css";

export default function SessionsTab({ detail }) {
  return (
    <div className={styles.tab}>
      <div className={styles.sectionLabel}>Active Sessions</div>
      <div className={styles.list}>
        {detail.sessions.map((s, i) => (
          <div key={i} className={styles.sessionCard}>
            <div className={styles.sessionTop}>
              <span className={styles.sessionRegion}>{s.region}</span>
              <span className={styles.statusPill} style={{ color: "var(--accent)" }}>
                <span className={styles.statusDot} style={{ background: "var(--accent)" }} />
                {s.status}
              </span>
            </div>
            <span className={styles.sessionMeta}>
              IP: {s.ip} · Duration: {s.duration}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
